import { z } from 'zod';
import { validateMessageLength } from '../utils/message-utils';

export const contactUsSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  emailID: z
    .string()
    .min(1, 'Email is required')
    .email('Please enter a valid email address'),
  subject: z.string().min(1, 'Subject is required'),
  message: z.string().refine(
    value => {
      const validation = validateMessageLength(value);
      return validation.isValid;
    },
    value => {
      const validation = validateMessageLength(value);
      return { message: validation.error || 'Invalid message' };
    }
  ),
  attachments: z.array(
    z.object({
      name: z.string(),
      extension: z.string(),
      url: z.string().optional(),
      fileId: z.string().optional(),
      isUploading: z.boolean(),
      progress: z.number()
    })
  )
});
